import {
  GET_AUDIT_LOGS,
  GET_AUDIT_LOG_STATS,
  GET_AUDIT_LOG_FILTER_OPTIONS,
  GET_AUDIT_LOG_DETAIL,
} from "../constants/actionTypes";

const defaultState = {
  logsResponse: {
    success: true,
    count: 0,
    limit: 50,
    offset: 0,
    data: [],
  },
  stats: {},
  filterOptions: {},
  detailById: {},
};

export default (state = defaultState, action) => {
  try {
    switch (action.type) {
      case GET_AUDIT_LOGS:
        return {
          ...state,
          logsResponse: {
            ...state.logsResponse,
            ...(action.payload || {}),
          },
        };
      case GET_AUDIT_LOG_STATS:
        return {
          ...state,
          stats: {
            ...(action.payload || {}),
          },
        };
      case GET_AUDIT_LOG_FILTER_OPTIONS:
        return {
          ...state,
          filterOptions: {
            ...(action.payload || {}),
          },
        };
      case GET_AUDIT_LOG_DETAIL:
        return {
          ...state,
          detailById: {
            ...state.detailById,
            [action?.payload?.id]: action.payload,
          },
        };
      default:
        return state;
    }
  } catch (error) {
    throw new Error(error);
  }
};
